export default __webpack_public_path__ + "static/media/NeonFood_Fries.6925ba84.gif";